var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup151(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 45,
    viewBox: "0 0 49 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_498_2257",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 45
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.5294 0H0V45H48.5294V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_498_2257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 22.4477C0 10.0465 10.8345 0 24.2083 0C37.5821 0 48.4166 10.0465 48.4166 22.4477C48.4166 34.8488 37.5821 44.8953 24.2083 44.8953C10.8345 44.8692 0 34.8227 0 22.4477Z",
    fill: "#5865F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0996 13.3172C33.0399 12.4539 30.8956 11.826 28.6666 11.4858C28.3845 11.9568 28.0741 12.5585 27.8484 13.0556C25.4783 12.7155 23.0801 12.7155 20.71 13.0556C20.4561 12.5062 20.174 11.9829 19.8636 11.4858C17.6346 11.826 15.4621 12.4539 13.4306 13.3434C9.36769 18.9684 8.26732 24.4364 8.8034 29.8521C11.2017 31.5004 13.8538 32.7562 16.7035 33.5411C17.3525 32.73 17.9168 31.8928 18.3964 31.0033C17.4653 30.6893 16.5907 30.2969 15.7442 29.826C15.97 29.669 16.1675 29.512 16.3932 29.355C21.3872 31.5527 27.1994 31.5527 32.1934 29.355C32.4192 29.512 32.6167 29.669 32.8424 29.826C31.9959 30.2969 31.0931 30.6893 30.162 31.0033C30.6416 31.8928 31.2059 32.73 31.8549 33.5411C34.7046 32.73 37.385 31.5004 39.755 29.8521C40.3757 23.573 38.6264 18.1312 35.0996 13.3172ZM19.0736 26.5033C17.5218 26.5033 16.2803 25.1951 16.2803 23.5992C16.2803 22.0033 17.5218 20.669 19.0736 20.669C20.6536 20.669 21.8951 21.9771 21.8951 23.5992C21.8668 25.1951 20.6536 26.5033 19.0736 26.5033ZM29.4566 26.5033C27.9048 26.5033 26.6633 25.1951 26.6633 23.5992C26.6633 22.0033 27.9048 20.669 29.4566 20.669C31.0366 20.669 32.2781 21.9771 32.2499 23.5992C32.2217 25.2213 31.0084 26.5033 29.4566 26.5033Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup151);
export default __webpack_public_path__ + "static/media/Group 151.d7cbc01a7c30e42021743ca75ee27fa7.svg";
export { ForwardRef as ReactComponent };